export const DEFAULT_LANG = 'fr';

export const FIRST_LOGIN_QUERY_PARAM_KEY = 'first-login';
export const RESET_CODE_QUERY_PARAM_KEY = 'reset-code';
export const APP_TYPE_QUERY_PARAM_KEY = 'type';

/**
 * Le portail est un client OAuth 2 à part entière — le cinquième, enregistré en phase 1 aux côtés des
 * quatre applications. L'identifiant est le même dans tous les environnements ; seules les URI de
 * redirection changent, et elles sont déduites de l'origine courante.
 */
export const PORTAL_OAUTH_CLIENT_ID = 'portail';

/**
 * `openid` seul : le portail aiguille, il n'appelle aucune API métier. C'est aussi ce qui est
 * enregistré côté serveur — demander plus rendrait `invalid_scope`.
 */
export const PORTAL_OAUTH_SCOPE = 'openid';

export const AUTH_CALLBACK_PATH = '/auth/callback';

/**
 * Où atterrit quelqu'un dont le navigateur refuse le cookie de session : sans lui,
 * `/oauth2/authorize` ne retrouve jamais la session et renverrait ici indéfiniment.
 */
export const COOKIES_REQUIRED_PATH = 'cookies-requis';
